import { render } from "./ContentAttachments.vue?vue&type=template&id=36d2f241&scoped=true"
import script from "./ContentAttachments.vue?vue&type=script&lang=js"
export * from "./ContentAttachments.vue?vue&type=script&lang=js"

import "./ContentAttachments.vue?vue&type=style&index=0&id=36d2f241&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d2f241"]])

export default __exports__